

import { Vue, Component, Watch, Prop } from "vue-property-decorator"

@Component({
    components: {
        SignatureField: () => import("@/components/fields/SignatureField.vue")
    }
})
export default class TransportDocumentContactEditDialog extends Vue {

    // @Prop({ default: null })
    contact?: any = null
    original: any
    show: boolean = false

    cancel() {
        this.show = false
        Object.assign(this.contact, this.original)
        this.original = null
        this.$emit('cancel')
    }

    save() {
        // validate, close and emit save
        if (!this.done)
            return false
        this.show = false
        this.$emit('save')
    }

    showDialog(contact: any) {
        this.contact = contact
        this.original = JSON.parse(JSON.stringify(contact))
        this.show = true
    }

    get done() {
        return this.contact.companyName
            && this.contact.address
            && this.contact.orgNo
            && this.contact.fullName
            && this.contact.emailAddress
            && this.contact.phoneNo
            && this.contact.signature
            && this.contact.signature.data
    }

    get title() {
        return this.typeTranslated
    }

    get type() {
        return this.contact?.type
    }

    get typeTranslated() {
        return this.$t(`transportDocument_contactType_${this.type}`) as string
    }
}
